import { jsxs as e, jsx as s } from "react/jsx-runtime";
import { clsx as l } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIBadge as r } from "../../badge/roche-badge.js";
import i from "./roche-diagnostics-item.module.scss.js";
import { rocheUIDiagnosticsItemVariantBadgeColor as g, RocheUIDiagnosticsItemVariant as _ } from "./roche-diagnostics-item.types.js";
const x = ({
  name: m,
  label: t,
  variant: a = _.OTHER,
  description: d,
  fields: c = []
}) => /* @__PURE__ */ e("div", { className: l(i["diagnostics-item"], i[`diagnostics-item--${a}`]), children: [
  /* @__PURE__ */ e("div", { className: i["diagnostics-item__product"], children: [
    t && /* @__PURE__ */ s("span", { className: i["diagnostics-item__badge"], children: /* @__PURE__ */ s(r, { text: t, color: g[a] }) }),
    /* @__PURE__ */ s("span", { className: i["diagnostics-item__name"], children: m })
  ] }),
  /* @__PURE__ */ s("p", { className: i["diagnostics-item__description"], children: d }),
  c.length > 0 && /* @__PURE__ */ s("dl", { className: i["diagnostics-item__fields"], children: c.map(({ label: o, value: n }) => /* @__PURE__ */ e("div", { className: i["diagnostics-item__field"], children: [
    /* @__PURE__ */ s("dt", { className: i["diagnostics-item__field-label"], children: o }),
    /* @__PURE__ */ s("dd", { className: i["diagnostics-item__field-value"], children: n })
  ] }, o)) })
] });
export {
  x as RocheUIDiagnosticsItem
};
